import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home/index";
import About from "./pages/about/index";
import Layout from "./layout/Layout";
import Packages from "./pages/packages/index";
import Activities from "./pages/activities/index";
import ContactUs from "./pages/contact/index";
import Attractions from "./pages/attractions/index";
import KnowMore from "./pages/[slug]";
import Ticket from "./components/Ticket/ticket";
import Courses from "./pages/courses/index";
import Hotels from "./pages/hotels/index";
import Destinations from "./pages/Destinations";
import DestPackages from "./pages/Destinations/[dest]";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/attractions" element={<Attractions />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/pages/:slug" element={<KnowMore />} />
          <Route path="/pages/Destinations/:dest" element={<DestPackages />} />
          <Route path="/ticket" element={<Ticket />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/hotels" element={<Hotels />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
